import *as React from 'react'

import { AppContext } from "../../../Context/AppContext"

import "./site.scss"

import { postier } from "./Postier"
import { Update } from './Update'
import { ReactElement, useContext, useEffect, useState } from 'react'
import { formatZipCode } from './zipcode'

export function Site(): ReactElement {

    const { site,siteList,token,client,sites, setSites,setLoading, setErrors, role } = useContext(AppContext)

    const [pagina, setPagina] = useState("main")

    const [zipCode, setZipCode] = useState<string>('')

    useEffect(()=>{
        const id_site = site.split(":")[0]

        if (id_site && client && id_site !== "Veuillez choisir un client") {
            setLoading(true)
            postier.getSite(token, client, id_site, setSites, setErrors)
        }
    },[site, client])

    useEffect(() => {
        formatZipCode(sites, setZipCode)
    }, [sites])

    const content = <>
        <h2>{sites.Name} </h2>
        {role !== 'Viewer' &&<button className="modif-button" onClick={() => { setPagina("modif") }} >Modifier</button>}
        <label>ID  </label><div className="label"> {sites.ID}</div>
        <label>Code  </label><div className="label"> {sites.Code}</div>
        <label>Pays  </label><div className="label"> {sites.Country}</div>
        {/* <label>IsMonitored  </label><div className="label"> <input type="checkbox" checked={sites.IsMonitored==1} onChange={e=>{e.preventDefault()}} /></div></div> */}
        <label>WeatherZipCode</label><div className="label"> {sites.WeatherZipCode}</div>
        <label>ZipCode</label><div className="label">{zipCode}</div>
    </>

    return (
        <div className="site">
			<h1>{!siteList[0]&&"veuillez créer un site"}</h1>
            { pagina === "main" && siteList[0] && content }
            { pagina === "modif" && siteList[0] && <Update setPage={setPagina} />}
        </div>
    )
}

